import { message } from "antd";
import axios from "axios";
import { AxiosError } from 'axios';
import { getIdToken } from "../../components/userManager/userManagementUtils";

export async function api_trigger_fxn(resource: string, payload: any) {
    let url = `${process.env.REACT_APP_API_URL}/${resource}`;
    let idToken;
    try {
        idToken = await getIdToken();
    } catch (err) {
        message.error("Failed to get id token.")
        throw err;
    }
    const headers = {
        'Authorization': `Bearer ${idToken}`,
        'Content-Type': 'application/json'
    };

    let response;
    try {
        response = await axios.post(url, payload, { headers });
    } catch (error) {
        let err = error as AxiosError; // Cast the error as AxiosError type
        if (!err.response) {
            message.error(`API ${err.message}`, 3);
            throw new Error('API request failed with message ' + err.message);
        } else {
            message.error(
                `API responded with status code ${err.response.status}: ${err.response.data}`,
                3
            );
            throw new Error('Request failed with status code ' + err.response.status);
        }
    }

    if (response.status === 200) {
        return response.data;
    }
    message.error(`API response error: ${response.status}`, 3);
    throw new Error('Request failed with status code ' + response.status);
}